import React from 'react';
import { toast } from 'react-toastify';
import { Button, } from 'reactstrap';
import { useToggle, } from 'react-use';

import firebase from '../firebase';
import useDocumentSubscription from './hooks/useDocumentSubscription';

const db = firebase.firestore();

export default function EditButton ({ label = '編集', validateOnSubmit = _ => true, itemRef, FormModal, formProps, processValues = _ => _, beforeUpdate = _ => _, onFinish = _ => _, withBatch = _ => _, ...extraProps }) {
  const [showsModal, toggleModal] = useToggle(false);
  const item = useDocumentSubscription(showsModal && itemRef, [showsModal]);
  const onSubmit = async (values) => {
    if(!(await validateOnSubmit({ id: itemRef.id, ...values }))) return;
    try {
      if((await beforeUpdate({ id: itemRef.id, ...values })) === false) return;

      const batch = db.batch();
      const processedValues = await processValues(values);
      batch.update(itemRef, processedValues);
      withBatch(batch, processedValues);
      await batch.commit();
      await onFinish(processedValues);
      toast.success('保存しました');
      toggleModal(false);
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
  };

  return (
    <Button color="secondary" onClick={_ => toggleModal(true)} {...extraProps}>
      <span className="fas fa-edit" />
      {label && <span className="ml-1">{label}</span>}
      {
        item && showsModal && (
          <FormModal itemRef={itemRef} isOpen values={item} onClickClose={_ => toggleModal(false)} onSubmit={onSubmit} {...formProps} />
        )
      }
    </Button>
  );
};
